import fetch_details from "@/apollo/flights/details/fetch_detail.gql";

export const state = () => ({
  details: {},
  loading: false
});

export const mutations = {
  /**
   * @description
   * @author Saurabh Jangra
   * @date 25 Aug 2023 | 12:21PM
   * @param {*} state
   * @param {*} value
   */
  setDetails(state, value) {
    state.details = value;
  },
  /**
   * @description
   * @author Saurabh Jangra
   * @date 25 Aug 2023 | 12:21PM
   * @param {*} state
   * @param {*} value
   */
  setLoading(state, value) {
    state.loading = value;
  }
};

export const actions = {
  /**
   * @description
   * @author Saurabh Jangra
   * @date 25 Aug 2023 | 12:20PM
   * @param {*} { commit }
   * @param {*} inventory_id
   * @returns {*}
   */
  fetchDetails({ commit }, inventory_id) {
    return new Promise(async () => {
      commit("setLoading", true);
      try {
        const {
          data: { fetch_inventories_details }
        } = await this.$apolloClient.query({ query: fetch_details, variables: { inventory_id } });
        if (fetch_inventories_details) {
          commit("setLoading", false);
          commit("setDetails", fetch_inventories_details);
        }
      } catch (error) {
        commit("setLoading", false);
      }
    });
  },
  /**
   * @description
   * @author Saurabh Jangra
   * @date 16 Oct 2023 | 03:36PM
   * @param {*} { commit }
   * @param {*} search_by
   * @returns {*}
   */
  refreshListing({ commit }, inventory_id) {
    return new Promise(async (resolve) => {
      const _result = this.$subscribeClient.iterate({
        query: `subscription { refresh_inventory_details }`
      });
      for await (const event of _result) {
        this.$apolloClient.query({ query: fetch_details, variables: { inventory_id } }).then(({ data }) => {
          commit("setDetails", data.fetch_inventories_details);
          resolve(data.fetch_inventories_details);
        });
      }
    });
  }
};

export const getters = {
  details: (state) => state.details,
  loading: (state) => state.loading
};
